import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { recordPayment } from './api';
import type { RecordPaymentInput } from './types';

export function useRecordPayment(billId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: RecordPaymentInput) => recordPayment(billId, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.billing.list() });
      queryClient.invalidateQueries({ queryKey: keys.billing.payments(billId) });
    },
  });
}
